module.exports = (transactions, filter) ->
  res = transactions.filter (tr) ->
    switch filter.type
      when 'incomes-expenses' then condition_type = tr.subtype == 'i' || tr.subtype == 'e'
      when 'incomes'          then condition_type = tr.subtype == 'i'
      when 'expenses'         then condition_type = tr.subtype == 'e'
      when 'transfers'        then condition_type = tr.subtype == 't'
      when 'planned'          then condition_type = tr.type == 'planned'
      when 'past_not_entered' then condition_type = tr.type == 'planned' && tr.isUnconfirmed() && tr.date < hm_date.constants.start_of_current_month
      when 'not_entered'      then condition_type = tr.type == 'planned' && tr.isUnconfirmed()
    return false if condition_type == false

    if filter.category
      if filter.category == '___no_category___'
        condition_category = _.isEmpty tr.category
      else
        condition_category = filter.category == tr.category || (filter.category == tr.baseCategory())
      return false if condition_category == false

    if filter.account_id
      account_ids = _.flatten([filter.account_id])
      condition_account_id = account_ids.map (acc_id) => tr.isRelatedToAccount(acc_id)
      return false if condition_account_id.every( (v) => v == false )

    if filter.virtual_id
      condition_virtual_id = tr.isRelatedToVirtual(filter.virtual_id)
      return false if condition_virtual_id == false

    if filter.description_match
      terms = filter.description_match.toLowerCase().split(' или ')
      for term in terms
        continue if _.isEmpty(term)
        condition_description_match = tr.description.toLowerCase().includes(term)
        return true if condition_description_match == true
      return false

    return true

  if filter.categories_included and filter.categories_included.length
    res = res.filter (tr) ->
      for category in filter.categories_included
        if category == '___no_category___'
          condition_category = _.isEmpty(tr.category)
        else
          condition_category = category == tr.category || (category == tr.baseCategory())
        return true if condition_category == true
      return false

  if filter.categories_excluded and filter.categories_excluded.length
    res = res.filter (tr) ->
      for category in filter.categories_excluded
        if category == '___no_category___'
          condition_category = _.isEmpty(tr.category)
        else
          condition_category = category == tr.category || (category == tr.baseCategory())
        return false if condition_category == true
      return true

  return res
